import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {MessageCategoriesState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: MessageCategoriesState = {
    messageCategories: [],
    messageCategoryItem: undefined,
    allowedTransports: [],
    regexRulesItem:[]
};


export const messageCategories: Module<MessageCategoriesState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
